import React from 'react';
import classNames from 'classnames';
import { formattedDate } from '../../../utils';
import { PaymentProfileType } from '../../../propTypes';

/**
 * Component to provide messaging and a link to the Stripe-hosted micro-deposits verification.
 * If micro-deposits verification is required, Stripe will send a webhook for "requires_action"
 * which will create the PaymentVerification for the PaymentProfile and populate the `gateway_action`
 * column, containing the hosted verification URL.
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
const StripeBankDebitVerify = (props) => {
  const { paymentProfile } = props;
  const { payment_verification: paymentVerification } = paymentProfile;
  const { gateway_action: gatewayAction } = paymentVerification;

  return (
    <React.Fragment>
      <h2>Verify Payment Account</h2>

      {paymentVerification.status === 'failed' && (
        <div className='alert alert-danger'>
          <h4>Payment Verification Failed</h4>
          <p>
            Verification of your payment account has failed. Please remove this payment account and attempt to add
            a different payment account.
          </p>
        </div>
      )}

      {!gatewayAction && (
        <p>
          The verification window for this payment account has expired.
          Please add a new payment method.
        </p>
      )}

      {gatewayAction && gatewayAction.type !== 'verify_with_microdeposits' && (
        <p>
          Please check your email for instructions on how to verify your payment account.
        </p>
      )}

      {gatewayAction && gatewayAction.type === 'verify_with_microdeposits' && (
        <div>
          <p>
            {`Micro-deposits were made to your payment account ${paymentProfile.name} `}
            {`and are expected to arrive by ${formattedDate(gatewayAction[gatewayAction.type].arrival_date * 1000)}.`}
          </p>
          <p>
            You must verify your payment account before continuing to use it for payments.
          </p>
          <a
            href={gatewayAction[gatewayAction.type].hosted_verification_url}
            className={classNames('btn', 'btn-primary', { disabled: paymentVerification.status === 'failed' })}
            target='_blank'
            rel='noopener noreferrer'
          >
            Verify Payment Account
          </a>
        </div>
      )}
    </React.Fragment>
  );
};

StripeBankDebitVerify.propTypes = {
  paymentProfile: PaymentProfileType.isRequired
};

export default StripeBankDebitVerify;
